import { render } from "./TheSiteGuidance.vue?vue&type=template&id=0b0ae5cb&scoped=true&ts=true"
import script from "./TheSiteGuidance.vue?vue&type=script&lang=ts"
export * from "./TheSiteGuidance.vue?vue&type=script&lang=ts"

import "./TheSiteGuidance.vue?vue&type=style&index=0&id=0b0ae5cb&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0ae5cb"]])

export default __exports__